export default {
  api_keys: "API-Schlüssel",
  api_docs: "Dokumentation",
  keys_count: "{current} / {total} Schlüssel",
  unnamed: "Unbenannt",
  edit_name: "Name bearbeiten",
  upgrade_to_enable: "Upgrade durchführen, um die API-Schlüsselfunktion zu aktivieren",
  no_api_keys: "Keine API-Schlüssel",
  generate_key: "Schlüssel generieren",
  upgrade_to_generate: "Upgrade durchführen, um einen Schlüssel zu generieren",
  api_calls: "API-Aufrufe",
  endpoint_stats: "Endpunkt-Aufrufstatistiken",
  refresh: "Aktualisieren",
  free_plan_api_stats:
    "Benutzer des kostenlosen Plans können keine API-Aufrufstatistiken anzeigen. Bitte führen Sie ein Upgrade durch, um detaillierte Daten anzuzeigen.",
  data_updates: "Datenaktualisierung alle 5 Minuten",
  api_call_logs: "API-Aufrufprotokolle",
  api_call_logs_desc:
    "Hier können nur Anfragen mit gültigen API-Schlüsseln eingesehen werden. Die Daten werden alle 5 Minuten aktualisiert",
  select_api_key: "API-Schlüssel auswählen",
  endpoint: "Endpunkt",
  response_time: "Antwortzeit",
  api_quota: "API-Kontingent",
  upgrade: "Upgrade",
  current_plan: "Aktueller Plan",
  key_count: "Schlüsselanzahl",
  call_limit: "Aufruflimit",
  no_access: "Kein Zugriff",
  daily_limit: "{limit} Aufrufe pro Tag",
  total_limit: "Gesamtlimit {limit} Aufrufe",
  monthly_limit: "{limit} Aufrufe pro Monat",
  calc_quota: "Berechnungskontingent",
  calc_and_report_quota: "Berechnungs- und Berichtskontingent",
  report_quota: "Berichtskontingent",
  daily_report_quota: "Tägliche Berichte",
  extra_quota: "Zusätzliches Kontingent: {count} Aufrufe",
  edit_key_name: "Schlüsselnamen bearbeiten",
  key_name: "Schlüsselname",
  key_name_placeholder: "Bitte geben Sie einen Schlüsselnamen ein",
  key_name_desc: "Geben Sie Ihrem API-Schlüssel einen leicht erkennbaren Namen",
  feature_restricted: "Funktion eingeschränkt",
  feature_restricted_desc1: "Ihr aktueller Plan kann diese Funktion nicht nutzen",
  feature_restricted_desc2:
    "Benutzer des kostenlosen Plans können keine API-Schlüsselfunktionen nutzen. Bitte führen Sie ein Upgrade auf einen kostenpflichtigen Plan durch, um alle Funktionen freizuschalten.",
  upgrade_benefits: "Vorteile des Upgrades:",
  benefit1: "API-Schlüssel generieren und verwalten",
  benefit2: "API-Aufrufstatistiken und Trends anzeigen",
  benefit3: "API-Schlüssel kopieren und verwenden",
  benefit4: "Höhere Berechnungs- und Berichtskontingente",
  benefit5: "Fortgeschrittenere Funktionen",
  response_data_details: "Antwortdatendetails",
  call_count: "{count} Aufrufe",
  name_required: "Name darf nicht leer sein",
  name_too_long: "Namenslänge darf 20 Zeichen nicht überschreiten",
  key_generated: "Schlüssel erfolgreich generiert",
  key_deleted: "Erfolgreich gelöscht",
  key_updated: "Name erfolgreich aktualisiert",
  upgrade_required: "Bitte führen Sie ein Upgrade durch",
  loading_docs: "API-Dokumentation wird geladen...",
  docs_load_error: "Fehler beim Laden der Dokumentation",
  docs_load_error_desc:
    "Beim Laden der API-Dokumentation ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  close_window: "Fenster schließen",
  delete_confirm: "Löschen bestätigen?",
  today: "Heute",
  this_month: "Diesen Monat",
  usage: "Nutzung",
  plan_quota: "Plan-Kontingent: {count} Aufrufe",
  name: "Name",
  api_key: "API-Schlüssel",
  created_at: "Erstellt am",
  action: "Aktion",
  response_status: "Statuscode",
  response_data: "Antwortdaten",
  call_count_name: "Aufrufanzahl",
  update_failed: "Aktualisierung fehlgeschlagen",
  restricted: "Eingeschränkt",
};
